import { useState, useRef, type DragEvent, type ChangeEvent } from "react";

type Props = {
  onFile: (file: File) => void;
  loading: boolean;
  error: string | null;
};

export function DropZone({ onFile, loading, error }: Props) {
  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  function onDrop(e: DragEvent<HTMLDivElement>) {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files?.[0];
    if (file) onFile(file);
  }

  function onPick(e: ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (file) onFile(file);
  }

  return (
    <div
      className={`dropzone ${dragOver ? "dropzone--over" : ""}`}
      onDragOver={(e) => {
        e.preventDefault();
        setDragOver(true);
      }}
      onDragLeave={() => setDragOver(false)}
      onDrop={onDrop}
      onClick={() => inputRef.current?.click()}
    >
      <input
        ref={inputRef}
        type="file"
        accept=".zip,application/zip"
        onChange={onPick}
        style={{ display: "none" }}
      />
      <div className="dropzone__inner">
        <h2>kilochain bundle viewer</h2>
        {loading ? (
          <p>Loading bundle…</p>
        ) : (
          <>
            <p>
              Drop a <code>kilochain-bundle-YYYY-MM-DD.zip</code> here, or click to pick one.
            </p>
            <p className="dropzone__hint">
              Generate one with <code>pnpm bundle-day</code>. Files are parsed entirely
              in your browser — nothing is uploaded.
            </p>
            {error && <p className="dropzone__error">{error}</p>}
          </>
        )}
      </div>
    </div>
  );
}
